import { render, staticRenderFns } from "./ViewRoles.vue?vue&type=template&id=dfa580d8&scoped=true"
import script from "./ViewRoles.vue?vue&type=script&lang=js"
export * from "./ViewRoles.vue?vue&type=script&lang=js"
import style0 from "./ViewRoles.vue?vue&type=style&index=0&id=dfa580d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack_7df808e90dc1ecdae917673cdf41e242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa580d8",
  null
  
)

export default component.exports